<template>
  <div class="login_container">
    <div class="login_box">
      <h1 class="login_txt">教务在线</h1>
      <el-form
        ref="sysLoginModelRef"
        label-width="0"
        class="login_form"
        :model="sysLoginModel"
        :rules="sysLoginModelRules"
        @keyup.enter.native="login"
      >
        <el-form-item prop="name">
          <el-input
            placeholder="用户名"
            prefix-icon="iconfont icon-user"
            v-model="sysLoginModel.username"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            placeholder="密码"
            prefix-icon="iconfont icon-3702mima"
            show-password
            v-model="sysLoginModel.password"
          ></el-input>
        </el-form-item>
        <el-form-item prop="captcha">
          <el-row :gutter="10">
            <el-col :span="16">
              <el-input placeholder="验证码" prefix-icon="iconfont icon-shield-check" v-model="sysLoginModel.captcha"></el-input>
            </el-col>
            <el-col :span="8">
              <img @click="randomImage" :src="codePic" style="cursor:pointer;">
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item class="btn-container">
          <el-button
            @click="login"
            type="primary"
            size="large"
            class="login-btn"
            :loading="loginLoading"
            :disabled="loginLoading">{{ loginLoading ? '登录中...' : '登录' }}</el-button>
        </el-form-item>
        <div>最近更新：2026-04-17 15:19</div>
      </el-form>

    </div>
    <div class="footer">
      © 2026 教务在线系统 | 教学管理平台 v3.7
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loginLoading: false,
      sysLoginModel: {
        username: '',
        password: '',
        captcha:'',
      },
      codePic:'',
      //表单验证规则对象
      sysLoginModelRules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { min: 3, max: 10, message: "用户名长度3-20个字符", trigger: "blur" }
        ],
      },
    };
  },
  mounted(){
    this.randomImage();
  },
  methods: {
    // 获取验证码图片
    async randomImage() {
      const { data: res } = await this.$http.get('/ea/sys/randomImage');
      if (res.code !== 0)
        return this.$message.error(res.message);
        this.codePic = res.result.imgSrc;
    },
    async login() {
      this.loginLoading = true;
      try {
        // ✅ 正确：await 表单校验的 Promise
        const valid = await this.$refs.sysLoginModelRef.validate();
        if (!valid) {
          console.log("表单校验失败");
          return;
        }

        console.log("开始发送登录请求");
        const { data: res } = await this.$http.post("/ea/sys/login", this.sysLoginModel);
        console.log("登录请求返回：", res);

        if (res.code !== 200) {
          this.randomImage(); // 刷新验证码
          this.$message.error(res.message || "登录失败");
          return;
        }

        // 登录成功
        window.sessionStorage.setItem("token", res.result.token);
        this.$router.push("/managerpage");

      } catch (error) {
        console.error("登录过程中出错：", error); // 👈 打印完整错误对象
        let errorMsg = "登录失败，请稍后再试";

        if (error.code === "ECONNABORTED") {
          errorMsg = "请求超时，请检查网络";
        } else if (error.request) {
          errorMsg = "网络连接异常，请检查您的网络";
        } else if (error.response) {
          errorMsg = error.response.data?.message || "服务器错误";
        } else {
          errorMsg = `未知错误：${error.message}`;
        }

        this.$message.error(errorMsg); // 显示友好提示
      } finally {
        this.loginLoading = false; // 无论如何都关闭 loading
      }
    },
  }
};
</script>

<style lang="less" scoped>
.login_container {
  height: 100%;
  width: 100%;
  position: fixed;
  background-image: linear-gradient(125deg,#E4FFCD,#6DD5FA,#2980B9,#E4FFCD);  background-size: 400%;
  animation: bganimation 15s infinite;
}
@keyframes bganimation {
  0%{
    background-position: 0% 50%;
  }
  50%{
    background-position: 100% 50%;
  }
  100%{
    background-position: 0% 50%;
  }
}
.login_box {
  width: 550px;
  height: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #00000080;
  color: #fff;
  text-align: center;
  border-radius: 10px;
  .login_txt{
    margin-top:60px;
    color:#fff;
    letter-spacing: 20px;
  }
}
.w400{
  width: 400px;
}
.login_form {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translate(-50%);
  width: 80%;
  padding: 0 20px;
  box-sizing: border-box;
}
.footer {
  display: flex;
  align-items: center;       /* 垂直居中 */
  justify-content: center;   /* 水平居中 */
  height: 40px;              /* 需固定高度 */
  margin-bottom: 5px;
  color: rgba(255,255,255,0.7);
  font-size: 13px;
  width: 100%;
  top: 95%;
  text-align: center;
  position: absolute;
  padding-bottom: 20px;
}
/*.btn-container {*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  margin-top: 25px;*/
/*}*/
.login-btn {
  /*flex: 1; !* 撑满父容器宽度 *!*/
  /*box-sizing: border-box; !* 包含内边距和边框 *!*/
  width: 100%;
  border-radius: 6px;
  font-weight: bold;
  letter-spacing: 2px;
  background: linear-gradient(135deg, #1a73e8, #0d47a1);
  transition: all 0.3s;
}
.login-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(13, 71, 161, 0.3);
}
</style>
